import { render, staticRenderFns } from "./29.vue?vue&type=template&id=1f98177a&scoped=true&"
import script from "./29.vue?vue&type=script&lang=js&"
export * from "./29.vue?vue&type=script&lang=js&"
import style0 from "./29.vue?vue&type=style&index=0&id=1f98177a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f98177a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f98177a')) {
      api.createRecord('1f98177a', component.options)
    } else {
      api.reload('1f98177a', component.options)
    }
    module.hot.accept("./29.vue?vue&type=template&id=1f98177a&scoped=true&", function () {
      api.rerender('1f98177a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/product/details/29.vue"
export default component.exports